{
  "title": "How to create judge assignments with \"Automatic balanced assignment\"",
  "description": "Propose and create an even set of judge assignments for submitted works, based on each judge's current workload and category.",
  "headings": [
    "What You'll Accomplish",
    "Applies To",
    "Before You Start",
    "Steps",
    "What You'll See",
    "FAQ"
  ],
  "summary": "After this, submitted works are spread evenly across judges at the number of judges per submission you chose, automatically skipping conflicts and existing assignments.",
  "roleNote": "Competition admin / staff with assignment management",
  "prerequisites": [
    "At least one judge has been invited",
    "A rubric exists",
    "There are submissions with status Submitted or Locked"
  ],
  "pathLabel": "Admin → My competitions → Review → Judges → Assignments → Automatic balanced assignment",
  "steps": [
    {
      "title": "1. Choose the settings",
      "description": "In \"Automatic balanced assignment\" at the top of the Assignments tab, choose the round (only needed for multi-round competitions), the rubric, and \"Judges per submission\" (1 to 10)."
    },
    {
      "title": "2. Preview the assignment",
      "description": "Press \"Preview assignment\". It shows how many assignments are planned, how many submissions they cover, and each judge's workload as \"now + new\". Previewing creates nothing; changing any setting discards the preview."
    },
    {
      "title": "3. Check the gaps",
      "description": "If some submissions cannot reach the target number of judges (conflicts or too few judges), the screen tells you how many. Invite more judges, or assign them by hand on the same page afterwards."
    },
    {
      "title": "4. Confirm and create",
      "description": "Press \"Apply assignment\" and confirm in the dialog; only then are assignments created. The system re-checks judge role, conflict of interest and duplicates for each one and records an audit entry each; it then shows how many were created and skipped."
    }
  ],
  "afterward": [
    "New assignments appear in each judge's list",
    "Judges receive one combined new-assignment email about 10 minutes later",
    "Existing assignments and conflicted pairs are not duplicated or forced"
  ],
  "nextSteps": "Track each judge's progress on the Review Progress page and use \"Remind judges to finish scoring\".",
  "faq": [
    {
      "q": "What is the assignment based on?",
      "a": "A judge's current total workload first (fewer gets work first), then, when loads are equal, a judge whose expertise matches the category name (the judge's own free text, only a tie-breaker), then the workload within that submission's category so each judge sees a mix, then a fixed order to break ties, so the same inputs give the same result."
    },
    {
      "q": "Will submissions I already assigned by hand be assigned again?",
      "a": "No. The system only fills in missing judges, counts existing assignments, and never gives one judge the same submission twice."
    },
    {
      "q": "What if I want to adjust one assignment afterwards?",
      "a": "On the Assignments tab you can change a single assignment's judge or rubric, or cancel it."
    }
  ]
}
